<!-- ── Header ─────────────────────────────────────────────── -->
<div class="pvd-header" mat-dialog-title>
  <span class="pvd-header__title">Política de Privacidad</span>
  <button mat-icon-button class="pvd-header__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- ── Body scrollable ───────────────────────────────────── -->
<mat-dialog-content class="pvd-body">

  <p>En este sitio web sólo se recaban datos personales con el conocimiento e información de los usuarios.</p>
  <p>
    En este documento le explicamos con detalle quién va a tratar sus datos, para qué se van a utilizar y cuáles son
    los derechos que puede ejercer entre otros puntos. Si quiere tener una mayor información puedes leer esta
    Política de Privacidad, así como el Aviso Legal y la Política de Cookies.
  </p>

  <h3 class="pvd-section">1. RESPONSABLES DE TRATAMIENTO. ¿QUIÉN VA A TRATAR SUS DATOS?</h3>
  <table class="pvd-table">
    <tbody>
      <tr><td>Identidad</td><td>HA Convfact S.L.</td></tr>
      <tr><td>Dirección</td><td>Camino La Montaña 1, 38480, Buenavista del Norte, Santa Cruz de Tenerife</td></tr>
      <tr><td>Email</td><td>administracion&#64;handly.es</td></tr>
    </tbody>
  </table>
  <p>
    HA Convfact S.L. es un programa de facturación y contabilidad, por lo que además de a los datos de sus
    USUARIOS, también tendrá acceso a los datos de los clientes y proveedores de estos.
    Por ello, HA Convfact S.L. actuará como ENCARGADO DEL TRATAMIENTO. El USUARIO será RESPONSABLE
    DEL TRATAMIENTO de los datos que se introduzcan en la web/app Handly.
    En las Condiciones y Términos se incluye el Contrato de Encargado del Tratamiento que regula esta relación
    respecto a la normativa actual de Protección de Datos.
  </p>

  <h3 class="pvd-section">2. ¿QUÉ DATOS PERSONALES TRATAMOS Y DE DÓNDE PROCEDEN?</h3>
  <p>
    Con motivo de su relación con nosotros podremos tratar distintas categorías de datos personales, dependiendo
    siempre del servicio o producto contratado con nosotros. Las categorías de datos tratadas podrán ser las siguientes:
  </p>
  <ul class="pvd-list">
    <li>Datos corporativos de entidades y datos de contacto de sus representantes o contactos.</li>
    <li>Carácter identificativo de personas físicas: nombre y apellidos, DNI/documento identificativo, teléfono, correo electrónico, dirección, firma, firma electrónica.</li>
    <li>Datos bancarios: Código BIC/Swift, IBAN, Entidad, Número de tarjeta, Caducidad.</li>
  </ul>
  <p>
    HA Convfact S.L. solo recogerá aquellos datos que sean estrictamente necesarios para la finalidad indicada.
    Cuando le pidamos que rellene sus datos personales para darle acceso a alguna funcionalidad o servicio,
    marcaremos algunos campos como obligatorios. Si decide no facilitarnos esos datos, es posible que no pueda
    disfrutar de esos servicios o funcionalidades.
  </p>

  <h3 class="pvd-section">3. FINALIDAD. ¿PARA QUÉ SE UTILIZAN SUS DATOS PERSONALES?</h3>
  <p>Las principales finalidades para las que se van a poder utilizar sus datos personales son las siguientes:</p>
  <table class="pvd-table pvd-table--wide">
    <thead>
      <tr><th>Finalidad</th><th>Más información</th></tr>
    </thead>
    <tbody>
      <tr>
        <td>Registro de usuario y uso de la web/app</td>
        <td>Para identificarle como usuario y darle acceso a las funcionalidades de la aplicación.</td>
      </tr>
      <tr>
        <td>Gestiones comerciales y administrativas</td>
        <td>Contactar con usted sobre actualizaciones, gestionar el pago de los servicios y facilitar facturas.</td>
      </tr>
      <tr>
        <td>Cumplimiento de obligaciones legales</td>
        <td>Cumplimiento de las obligaciones de índole contable, legal, fiscal y administrativa.</td>
      </tr>
      <tr>
        <td>Concursos, sorteos y eventos</td>
        <td>Gestión de su participación en concursos, sorteos y actividades en las que haya solicitado participar.</td>
      </tr>
      <tr>
        <td>Encuestas de calidad</td>
        <td>Remisión de encuestas para evaluar el nivel de satisfacción con los productos y/o servicios contratados.</td>
      </tr>
      <tr>
        <td>Comunicaciones comerciales</td>
        <td>Envío de comunicaciones sobre ofertas y servicios. Podrá oponerse a recibirlas en cualquier momento.</td>
      </tr>
      <tr>
        <td>Consultas, solicitudes o sugerencias</td>
        <td>Gestión de la consulta, solicitud o sugerencia trasladada por el interesado.</td>
      </tr>
    </tbody>
  </table>

  <h3 class="pvd-section">4. LEGITIMACIÓN. ¿POR QUÉ USAMOS SUS DATOS PERSONALES?</h3>
  <table class="pvd-table pvd-table--wide">
    <thead>
      <tr><th>Finalidad</th><th>Legitimación</th></tr>
    </thead>
    <tbody>
      <tr><td>Registro de usuario y uso de la web/app</td><td>Su consentimiento</td></tr>
      <tr><td>Gestiones comerciales y administrativas</td><td>Ejecución contractual</td></tr>
      <tr><td>Cumplimiento de obligaciones legales</td><td>Ejecución contractual y obligación legal</td></tr>
      <tr><td>Concursos, sorteos y eventos</td><td>Su consentimiento</td></tr>
      <tr><td>Encuestas de calidad</td><td>Interés legítimo de HA Convfact S.L.</td></tr>
      <tr><td>Comunicaciones comerciales</td><td>Interés legítimo / su consentimiento</td></tr>
      <tr><td>Consultas, solicitudes o sugerencias</td><td>Su consentimiento e interés legítimo</td></tr>
    </tbody>
  </table>

  <h3 class="pvd-section">5. CONSERVACIÓN DE TUS DATOS. ¿CUÁNTO TIEMPO LOS CONSERVAREMOS?</h3>
  <p>
    Los datos personales proporcionados se conservarán durante el tiempo necesario para cumplir con la finalidad
    para la que se recaban. Una vez finalizado este plazo los conservaremos debidamente guardados y protegidos
    durante los plazos de prescripción legal exigidos.
  </p>

  <h3 class="pvd-section">6. ¿A QUIÉN COMUNICAMOS SUS DATOS?</h3>
  <p>Para cumplir las finalidades indicadas, es necesario que demos acceso a sus datos a:</p>
  <ul class="pvd-list">
    <li>Entidades financieras, pasarelas de pago y demás terceros que faciliten transacciones de pago.</li>
    <li>Proveedores de servicios tecnológicos: Amazon Virtual Private Cloud (servidor virtual), ABBYY Europe GmbH (digitalización).</li>
    <li>Entidades de asesoramiento empresarial.</li>
  </ul>
  <p>
    HA Convfact S.L. no cederá los datos personales a terceros excepto por obligación legal. En caso de cesión,
    se informará previamente al usuario solicitando consentimiento expreso.
  </p>

  <h3 class="pvd-section">7. DERECHOS QUE PUEDE EJERCER</h3>
  <p>Puede ejercitar cualquiera de los siguientes derechos indicándonos el motivo y el derecho que desea ejercitar:</p>
  <ul class="pvd-list">
    <li>Acceso a sus datos personales.</li>
    <li>Rectificación de sus datos.</li>
    <li>Supresión de sus datos cuando ya no sean necesarios.</li>
    <li>Limitación del tratamiento de sus datos.</li>
    <li>Portabilidad de sus datos personales.</li>
    <li>Oposición al tratamiento cuando esté basado en interés legítimo.</li>
  </ul>
  <p>Puede ejercitar sus derechos por correo postal en Camino La Montaña 1, 38480, Buenavista del Norte o por correo electrónico en administracion&#64;handly.es.</p>
  <p>
    En caso de considerar vulnerado su derecho a la protección de datos puede interponer una reclamación ante
    la Agencia Española de Protección de Datos, <span class="pvd-url">www.aepd.es</span>.
  </p>

  <h3 class="pvd-section">8. DATOS DE TERCEROS</h3>
  <p>
    Si nos proporciona datos de terceras personas, garantiza haberles informado acerca de las finalidades y la
    forma en la que necesitamos tratar sus datos personales.
  </p>

  <h3 class="pvd-section">9. CAMBIOS A LA POLÍTICA DE PRIVACIDAD</h3>
  <p>
    Es posible que modifiquemos esta Política cuando lo estimemos conveniente. En caso de cambios significativos
    se lo notificaremos a su dirección de correo electrónico.
  </p>

  <h3 class="pvd-section">10. ¿ALGUNA CONSULTA?</h3>
  <p>
    Para cualquier duda sobre esta política puede contactar en administracion&#64;handly.es.
  </p>

</mat-dialog-content>

<!-- ── Actions ───────────────────────────────────────────── -->
<mat-dialog-actions class="pvd-actions">
  <button mat-flat-button class="pvd-accept" (click)="closeDialog()">Acepto y cierro</button>
</mat-dialog-actions>
